import LeadForm from './LeadForm';
import PageMeta from './PageMeta';
import { RedesignFooter, RedesignHeader, RedesignPage, SiteLink } from './RedesignShell';

const timelineItems = [
  {
    title: '2019 — Начало',
    text: 'Основатель агентства Гияс Фаталиев, будучи студентом технического вуза, взял первый коммерческий проект -  разработку сложного сайта с интеграциями. Никакой команды, только знания, упорство и желание сделать лучше всех. Реализовал проект самостоятельно. Именно тогда появилась идея: строить агентство, которое делает сложные вещи - просто и надёжно.',
  },
  {
    title: '2020–2023 — Команда и первые большие проекты',
    text: 'Репутация технаря, который всегда в срок и всегда честно, привлекла первых партнёров. Гияс собрал команду: дизайнер, два fullstack-разработчика, SMM-специалист. Проекты вёл лично. Параллельно появился крупный стратегический партнёр,  и в рамках этого партнёрства агентство реализовало более 30 проектов. Команда в это время упаковывала агентство изнутри: сайт, соцсети, процессы, продуктовый подход.',
  },
  {
    title: '2023–2024 — Мобильная экспертиза и рост команды',
    text: 'Агентство сделало ставку на мобильную разработку  и не ошиблось. Активный рост числа проектов по созданию и публикации мобильных приложений. Команда выросла до 10 человек: появились менеджеры проектов, аналитик, тестировщик.Также Fatality Studio разработала собственную CMS-систему, которая адаптируется под любые задачи: интернет-магазины, корпоративные сайты, каталоги, ресторанные меню с онлайн-заказом, сервисные платформы и даже мобильные приложения. Одна система — любой бизнес.Процессы стали зрелыми. Качество выше.',
  },
  {
    title: '2024–2026 — Собственный продукт и экосистема',
    text: 'Fatality Studio разработала собственную CMS-систему. Теперь клиент получает не просто сайт или приложение, а полноценную цифровую экосистему: сайт, мобильное приложение, мини-приложения в ВКонтакте, Telegram и MAX, единая CRM-панель и административный кабинет. Начали внедрять AI/ML-инструменты в проекты: умные рекомендации, автоматизация, чат-боты и аналитика на основе данных. LTV клиента - не менее 8 месяцев. Средний чек проектов в портфеле - от 1 млн рублей. Только позитивные отзывы.',
  },
  {
    title: '2026–2027 — Ваш проект',
    text: 'Мы ждём вас. Если вам нужен надёжный технологический партнёр, который понимает бизнес и умеет строить продукты - Вы уже на правильной странице.',
  },
];

const trustItems = [
  {
    title: 'Технический фундамент',
    text: 'Агентство основано разработчиком, а не маркетологом. Мы говорим с вами честно о сложности, сроках и бюджете.',
  },
  {
    title: 'Собственная CMS и экосистема',
    text: 'Не зависим от чужих платформ. Ваш продукт  на нашем надёжном стеке с понятным административным интерфейсом.',
  },
  {
    title: 'Долгосрочные отношения',
    text: 'LTV клиента - 8+ месяцев. Мы не исчезаем после сдачи проекта. Мы растём вместе с вашим бизнесом.',
  },
  {
    title: 'Проекты уровня enterprise',
    text: 'Средний чек проектов в портфеле - от 1 000 000 рублей. Мы умеем работать со сложными интеграциями, высокими нагрузками и строгими дедлайнами.',
  },
];

const facts = [
  '7 лет на рынке',
  '10+ специалистов в команде',
  '200+ проектов реализовано',
  '8+ месяцев средний LTV клиента',
  'от 1 млн ₽ средний чек в портфеле',
  '100% положительных отзывов',
];

const values = [
  {
    title: 'Честность прежде всего',
    text: 'Мы не обещаем того, что не можем сделать. Если задача нам не подходит — скажем прямо.',
  },
  {
    title: 'Ответственность за результат',
    text: 'Дедлайн — это обязательство, а не ориентир. Качество — не опция, а стандарт.',
  },
  {
    title: 'Технологии на службе бизнеса',
    text: 'Мы следим за рынком и внедряем то, что реально работает: собственная CMS, мини-приложения, мобильная разработка, CRM-интеграции и AI/ML-решения под задачи бизнеса.',
  },
  {
    title: 'Партнёрство, а не подряд',
    text: 'Нам важно, чтобы ваш продукт рос. Поэтому мы остаёмся рядом после запуска.',
  },
];

function SectionHeader({ eyebrow, children, description, dark = false }) {
  return (
    <div className={`sec-head${dark ? ' ink-head' : ''}`}>
      <div>
        <div className={`eyebrow${dark ? ' cyan' : ''}`}>— {eyebrow}</div>
        <h2>{children}</h2>
      </div>
      {description && <p className="sub">{description}</p>}
    </div>
  );
}

function ServiceGrid({ items }) {
  return (
    <div className="svc-grid">
      {items.map((item, index) => (
        <div className="svc static-svc" key={item.title}>
          <div className="svc-top">
            <span className="svc-num">{String(index + 1).padStart(2, '0')}</span>
            <span className="svc-arrow">/</span>
          </div>
          <div className="svc-title">{item.title}</div>
          <p className="svc-desc">{item.text}</p>
        </div>
      ))}
    </div>
  );
}

function Timeline({ items }) {
  return (
    <ol className="about-timeline" aria-label="Наш путь с 2019 года">
      {items.map((item) => (
        <li className="about-timeline-item" key={item.title}>
          <span className="about-timeline-dot" aria-hidden="true" />
          <div className="about-timeline-title">{item.title}</div>
          <p className="about-timeline-text">{item.text}</p>
        </li>
      ))}
    </ol>
  );
}

function TrustGrid({ items }) {
  return (
    <div className="why-grid about-trust-grid">
      {items.map((item, index) => (
        <div className="why about-trust-card" key={item.title}>
          <span className={`about-trust-icon about-trust-icon-${index + 1}`} aria-hidden="true" />
          <div className="why-title">{item.title}</div>
          <p className="why-d">{item.text}</p>
        </div>
      ))}
    </div>
  );
}

function AboutRedesignPage() {
  return (
    <RedesignPage>
      <PageMeta
        title="О компании Fatality Studio — digital-агентство полного цикла в Москве с 2019 года"
        description="Fatality Studio - команда из 10+ специалистов, которая с 2019 года создаёт сайты, мобильные приложения и мини-приложения для бизнеса. Собственная CMS, честный подход, проекты от 1 млн рублей. Узнайте нашу историю и достижения."
      />
      <RedesignHeader />

      <section className="ink hero" data-screen-label="about hero">
        <div
          className="glow"
          style={{ right: '-360px', top: '-360px', width: '1000px', height: '1000px', opacity: 0.1 }}
        />
        <div className="container" style={{ position: 'relative' }}>
          <div className="eyebrow cyan">— Fatality Studio</div>
          <h1>
            О <span className="accent">компании</span>
          </h1>
          <p className="hero-sub">
            Fatality Studio — digital-агентство полного цикла из Москвы. Мы создаём сайты, мобильные приложения и
            экосистемы для бизнеса с 2019 года.
          </p>
          <div className="hero-ctas">
            <SiteLink href="#about-lead" className="btn btn-primary">
              Обсудить проект
            </SiteLink>
            <SiteLink href="/portfolio/" className="btn btn-ghost-dark">
              Посмотреть наше портфолио
            </SiteLink>
          </div>
          <div className="hero-meta">
            {facts.slice(0, 4).map((item) => {
              const [num, ...label] = item.split(' ');
              return (
                <div key={item}>
                  <div className="num">{num}</div>
                  <div className="lbl">{label.join(' ')}</div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad" data-screen-label="about who">
        <div className="container">
          <SectionHeader
            eyebrow="команда"
            description="Fatality Studio — это команда разработчиков, дизайнеров, аналитиков и маркетологов, которая превращает идеи бизнеса в работающие цифровые продукты."
          >
            Кто <span className="accent">мы</span>
          </SectionHeader>
          <div className="case-spot">
            <figure className="about-visual">
              <img
                src="/images/about/fatality-mascot.webp"
                alt="Маскот Fatality Studio рядом со знаком F/ и логотипом агентства"
                width="1403"
                height="1121"
                loading="lazy"
                decoding="async"
              />
              <figcaption>
                <span>с 2019 года</span>
                <span>Москва · digital-агентство полного цикла</span>
              </figcaption>
            </figure>
            <div className="case-body home-copy">
              <p>
                Мы не просто делаем красивые сайты. Мы строим цифровую инфраструктуру: от лендинга до мобильного
                приложения, мини-приложений во ВКонтакте, Telegram и MAX, с собственной CMS-системой и CRM-панелью
                управления и внедрением AI/ML-решений для автоматизации бизнес-процессов.
              </p>
              <p>
                За 7 лет работы мы прошли путь от одного проекта до агентства с постоянными клиентами, средний LTV которых
                — более 8 месяцев. В нашем портфеле — проекты с бюджетом от 1 миллиона рублей, сложные интеграции и
                продукты, которыми пользуются тысячи людей каждый день. Посмотреть наше портфолио -{' '}
                <SiteLink href="https://fatalitystudio.ru/portfolio/" className="inline-link">
                  https://fatalitystudio.ru/portfolio/
                </SiteLink>
                .
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="ink sec-pad" data-screen-label="about timeline">
        <div
          className="glow"
          style={{ left: '-280px', top: '-280px', width: '700px', height: '700px', opacity: 0.08 }}
        />
        <div className="container" style={{ position: 'relative' }}>
          <SectionHeader dark eyebrow="история">
            Наш путь <span className="accent">с 2019 года</span>
          </SectionHeader>
          <Timeline items={timelineItems} />
          <SiteLink href="#about-lead" className="btn btn-primary section-action">
            Обсудить проект
          </SiteLink>
        </div>
      </section>

      <section className="canvas sec-pad" data-screen-label="about ceo">
        <div className="container">
          <SectionHeader eyebrow="руководитель">Руководитель агентства</SectionHeader>
          <div className="case-spot">
            <figure className="about-visual about-leader-photo">
              <img src="/images/about/giyas-fataliev.webp" alt="Гияс Фаталиев — основатель и CEO Fatality Studio" width="960" height="1280" loading="lazy" decoding="async" />
              <figcaption><span>CEO</span><span>Гияс Фаталиев</span></figcaption>
            </figure>
            <div className="case-body home-copy">
              <div className="case-title">Гияс Фаталиев — основатель и CEO Fatality Studio</div>
              <p>
                Гияс - технарь по образованию и предприниматель по призванию. Высшее техническое образование дало ему
                понимание продукта изнутри: он сам писал код, сам проектировал архитектуру, сам брал ответственность за
                результат.
              </p>
              <p>В 2019 году он взял первый проект  и закрыл его на отлично. Потом ещё один. Потом собрал команду. Потом вырастил агентство.</p>
              <p>
                Сегодня Гияс руководит командой из 10+ человек, лично участвует в брифинге ключевых клиентов и отвечает за
                стратегическое развитие агентства. Его философия простая: делать честно, делать в срок, делать так, чтобы
                клиент возвращался.
              </p>
              <p>Именно поэтому средний клиент Fatality Studio работает с агентством более 8 месяцев.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="ink sec-pad" data-screen-label="about trust">
        <div className="container">
          <SectionHeader dark eyebrow="доверие">
            Почему нам <span className="accent">доверяют</span>
          </SectionHeader>
          <TrustGrid items={trustItems} />
        </div>
      </section>

      <section className="canvas sec-pad" data-screen-label="about facts">
        <div className="container">
          <SectionHeader eyebrow="факты">Цифры и факты</SectionHeader>
          <div className="trust-grid facts-trust-grid">
            {facts.map((item, index) => (
              <div className="trust" key={item}>
                {item}
                <span className="role">{String(index + 1).padStart(2, '0')}</span>
              </div>
            ))}
          </div>
          <div style={{ marginTop: '32px', textAlign: 'center' }}>
            <SiteLink href="/portfolio/" className="link-flat">
              Посмотреть наши работы
            </SiteLink>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad" style={{ paddingTop: 0 }} data-screen-label="about values">
        <div className="container">
          <div className="section-top-line">
            <SectionHeader eyebrow="ценности">Наши ценности</SectionHeader>
            <ServiceGrid items={values} />
          </div>
        </div>
      </section>

      <section className="ink lead" id="about-lead" data-screen-label="about lead">
        <div
          className="glow"
          style={{ left: '-300px', top: '-200px', width: '700px', height: '700px', opacity: 0.1 }}
        />
        <div className="container" style={{ position: 'relative' }}>
          <div className="lead-grid">
            <div className="lead-side">
              <div className="eyebrow cyan">— заявка</div>
              <h2 className="lead-heading">Готовы работать с вами?</h2>
              <p className="lead-text">
                Расскажите о своём проекте — и мы предложим решение, которое реально работает. Наши контакты -{' '}
                <SiteLink href="https://fatalitystudio.ru/contacts/" className="inline-link">https://fatalitystudio.ru/contacts/</SiteLink>
              </p>
            </div>
            <LeadForm
              formId="about-lead-form"
              idPrefix="about"
              contactLabel="Телефон"
              contactType="tel"
              contactPlaceholder="+7 (___) ___-__-__"
              showCompany={false}
              submitLabel="Обсудить проект"
              taskPlaceholder="Расскажите о своём проекте"
            />
          </div>
        </div>
      </section>

      <RedesignFooter />
    </RedesignPage>
  );
}

export default AboutRedesignPage;
